module.exports = __webpack_public_path__ + "static/stageSet8-a0bf3122bd04afda47724b8baae742a8.jpg";